export default __webpack_public_path__ + "static/media/facebook.3f7115f9.svg";